import type { Role } from './auth'

// ─── Notice types (based on backend Prisma model) ───────────────

export const NOTICE_PRIORITIES = ['low', 'medium', 'high'] as const
export type NoticePriority = (typeof NOTICE_PRIORITIES)[number]

export const NOTICE_TYPES = ['info', 'warning', 'danger'] as const
export type NoticeType = (typeof NOTICE_TYPES)[number]

export const NOTICE_MEDIA_KINDS = ['image', 'video'] as const
export type NoticeMediaKind = (typeof NOTICE_MEDIA_KINDS)[number]

export type NoticeStatus = 'scheduled' | 'active' | 'expired' | 'inactive'

export interface NoticeMedia {
	id: string
	kind: NoticeMediaKind
	url: string
}

// Espelha a whitelist e os limites do backend (notice-schema.ts)
export const NOTICE_MEDIA_ACCEPT =
	'image/jpeg,image/png,image/webp,video/mp4,video/webm'
export const NOTICE_IMAGE_MAX_BYTES = 10 * 1024 * 1024
export const NOTICE_VIDEO_MAX_BYTES = 200 * 1024 * 1024
// Um aviso aceita até 10 imagens (carrossel) ou 1 vídeo
export const NOTICE_MAX_IMAGES = 10

export interface Notice {
	id: string
	branchIds: string[]
	/** Perfis que recebem o aviso; vazio = todos os perfis */
	roles: Role[]
	title: string
	message: string
	priority: NoticePriority
	type: NoticeType
	startsAt: string | null
	endsAt: string | null
	/** Imagens do carrossel (até 10) ou um vídeo, na ordem de exibição */
	media: NoticeMedia[]
	status: NoticeStatus
	isActive: boolean
	isGlobal: boolean
	createdAt: string
	updatedAt: string
	isRead: boolean
}

export interface NoticeWithReadStatus extends Notice {
	isRead: boolean
}

export interface NoticeListOutput {
	items: NoticeWithReadStatus[]
	pagination: {
		page: number
		limit: number
		total: number
		totalPages: number
	}
}

export interface NoticeInput {
	branchIds?: string[]
	/** true envia para todos os perfis; false exige `roles` */
	allRoles?: boolean
	roles?: Role[]
	title: string
	message: string
	priority: NoticePriority
	type: NoticeType
	/** Datas só-dia (yyyy-MM-dd); string vazia limpa o campo */
	startsAt?: string | null
	endsAt?: string | null
	isActive?: boolean
	isGlobal?: boolean
	/** Arquivos novos, entram depois das mídias mantidas */
	mediaFiles?: File[]
	/** Mídias já gravadas que continuam no aviso, na ordem do carrossel */
	keepMediaIds?: string[]
}
